//file: src/firestoreModel.js

import { initializeApp } from "firebase/app";
import { getFirestore, doc, setDoc, getDoc } from "firebase/firestore";
import { firebaseConfig } from "./firebaseConfig";
import { createUserWithEmailAndPassword,signInWithEmailAndPassword  } from "firebase/auth";
import { auth } from "./firebaseAuth";


const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const COLLECTION = "userModels";
const getUserDocRef = (uid) => doc(db, COLLECTION, uid);

export const connectToReduxPersistence = async (store, updateActionCreator, uid) => {
  if (!uid) {
    console.warn("UID is required to sync user data");
    return;
  }

  console.log("Setting up Firestore persistence for user:", uid);
  const docRef = doc(db, "users", uid);

  // Step 1: Load initial state from Firestore
  try {
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const user = docSnap.data();
      console.log("User document found:", user);

      // Correct: dispatch userProfile and userProgress
      store.dispatch(updateActionCreator({
        userProfile: user.userData.userProfile || {},
        userProgress: user.userData.userProgress || { score: 0, stockholm: {} },
      }));

    } else {
      console.warn("User document not found in Firestore");
    }
  } catch (err) {
    console.error("Error loading Firestore data:", err);
  }

  // Step 2: Watch store for changes and sync to Firestore

  let prevState = store.getState();

  store.subscribe(() => {
    const state = store.getState();
    if (!state.ready) return;

    const currentUser = auth.currentUser;
    if (!currentUser) return; // stop syncing if logged out

    const changed =
      JSON.stringify(state.userData) !== JSON.stringify(prevState.userData) ||
      state.ready !== prevState.ready;

    if (changed) {
      const stateToSave = {
        userData: state.userData,
        ready: state.ready,
      };
      setDoc(docRef, stateToSave, { merge: true });
      prevState = state;
    }
  });
};

async function signUpUser(email, password, firstName, lastName) {
  const userCredential = await createUserWithEmailAndPassword(auth, email, password);
  const user = userCredential.user;

  await setDoc(doc(db, "users", user.uid), {
    ready: true,
    userData: {
      userProfile: {
        firstName: firstName || "",
        lastName: lastName || "",
        email: email || "",
        Uid: user.uid || ""
      },
      userProgress: {
        score: 0,
        stockholm: {}
      }
    }
  });
}

async function signInUser(email, password) {
  const userCredential = await signInWithEmailAndPassword(auth, email, password);
  const user = userCredential.user;

  // Fetch user profile from subcollection
  const docRef = doc(db, "users", user.uid);
  const docSnap = await getDoc(docRef);

  if (!docSnap.exists()) throw new Error("User profile not found");


}



export { db, signUpUser,signInUser };
